// extracted by mini-css-extract-plugin
export default {"messageWrapper":"FlashMessage_messageWrapper__L6Gmi","successStyle":"FlashMessage_successStyle__Vn+kW","errorStyle":"FlashMessage_errorStyle__-OtKS"};